import Component from '../core/Component';

export const STATES = {
    ACTIVE: 'is-active',
}

export default class SwitchBackground extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            images: [],
            links: []
        }

        this.activeImage = 0
        this.activeSrc = this.ref.links[0].dataset.src
    }

    prepare() {
        this.ref.links.map($link => {
            $link.addEventListener('mouseenter', this.handleMouseEnter)
            $link.addEventListener('focus', this.handleFocus)
        })
    }

    handleMouseEnter = (event) => {
        let target = event.target

        this.switchImage(target)
    }

    handleFocus = event => {
        let target = event.target

        this.switchImage(target)
    }

    switchImage(target) {
        let src = target.dataset.src
        let srcset = target.dataset.srcset
        let alt = target.dataset.alt

        if (this.activeSrc == src) {
            return
        }

        this.ref.images[this.activeImage].classList.remove(STATES.ACTIVE)

        this.activeImage = this.activeImage ? 0 : 1

        this.ref.images[this.activeImage].src = (src) ? src : ''
        this.ref.images[this.activeImage].srcset = (srcset) ? srcset : ''
        this.ref.images[this.activeImage].alt = (alt) ? alt : ''

        this.ref.images[this.activeImage].classList.add(STATES.ACTIVE)

        this.activeSrc = src
    }
}